<h5>Selected Clients: </h5>
<div style=" height: 370px;background: white;overflow: auto;padding: 30px;" class=" mat-elevation-z8">


  <div *ngFor="let client of prestatairesClientList" style="text-align: left;">
 
    {{client.raisonSocial}}
   
     <button   (click)="remove(client)">
         <mat-icon    >remove</mat-icon>
     </button> 


  </div>
</div>